export const formatCentsToCurrency = (amountInCents?: number, addFractionDigits = true) => {
  if (amountInCents === undefined) {
    return;
  }
  const amountInDollars = amountInCents / 100;
  const RemainingCents = amountInCents % 100;
  const shouldHaveDecimals = addFractionDigits || RemainingCents > 0;
  return formatDisplayAmount(amountInDollars, shouldHaveDecimals);
};

export const formatDisplayAmount = (amountInDollars?: number, shouldHaveDecimals = true) => {
  if (amountInDollars === undefined) {
    return;
  }

  return amountInDollars.toLocaleString(undefined, {
    maximumFractionDigits: shouldHaveDecimals ? 2 : 0,
    minimumFractionDigits: shouldHaveDecimals ? 2 : 0,
    style: 'currency',
    currency: 'USD',
  });
};

export const COMPACT_CURRENCY_THRESHOLD_CENTS = 100000;

/**
 * Formats an amount in cents into compact currency notation (e.g. for buttons or tight UI spaces).
 *
 * Formatting rules:
 * - Returns `undefined` if `amountInCents` is undefined.
 * - Amounts < $1,000 (3 digits or fewer): Standard currency format (e.g. 5000 -> "$50", 99900 -> "$999").
 * - Amounts >= $1,000 (4 digits or more): Compact notation with 'K', 'M', etc., up to 1 decimal place,
 *   dropping trailing zeros (e.g. 100000 -> "$1K", 1420000 -> "$14.2K", 3300000 -> "$33K", 100000000 -> "$1M").
 *
 * @param amountInCents Amount in cents to format
 * @param addFractionDigits Whether to always include cents/fraction digits for amounts < $1,000 (defaults to false)
 * @returns Formatted currency string or undefined
 */
export const formatCentsToCompactCurrency = (amountInCents?: number, addFractionDigits = false) => {
  if (amountInCents === undefined) {
    return;
  }
  const amountInDollars = amountInCents / 100;
  const absDollars = Math.abs(amountInDollars);

  if (absDollars < 1000) {
    return formatCentsToCurrency(amountInCents, addFractionDigits);
  }

  return amountInDollars
    .toLocaleString(undefined, {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 1,
      style: 'currency',
      currency: 'USD',
    })
    .toUpperCase();
};

export const convertToCents = (amount: number) => {
  return Math.round(amount * 100);
};

export const convertToDollars = (amountInCents: number) => {
  return amountInCents / 100;
};
